import { render, staticRenderFns } from "./yi_tabs.vue?vue&type=template&id=2aff658d&scoped=true&"
import script from "./yi_tabs.vue?vue&type=script&lang=js&"
export * from "./yi_tabs.vue?vue&type=script&lang=js&"
import style0 from "./yi_tabs.vue?vue&type=style&index=0&id=2aff658d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff658d",
  null
  
)

export default component.exports